function formatCurrency(value?: number, prefix?: string) {
  if (value !== undefined && value !== null) {
    const result = new Intl.NumberFormat('in-ID', {
      style: 'decimal',
      maximumFractionDigits: 0,
    }).format(Math.abs(value));

    const withPrefix = `${prefix ? `${prefix} ` : ''}${result}`;

    return value < 0 ? `(${withPrefix})` : withPrefix;
  }

  return '';
}

function formatDecimal(data: number | string) {
  return data.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
}

export { formatCurrency, formatDecimal };
